export const HS_GAIL_ACCOUNT_ID_KEY = "GailHSAccountId";
export const HS_GAIL_ACCOUNT_EMAIL_KEY = "GailHSAccountEmail";
